function initCartRecommendationsSwiper() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initCartRecommendationsSwiper, 500);
    return;
  }

  try {
    var cartRecSwiper = new Swiper('#cart-recommendations-slider', {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      speed: 300,
      navigation: {
        nextEl: '#cart-recommendations-next',
        prevEl: '#cart-recommendations-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 1.3,
          spaceBetween: 10
        }
      },
      on: {
        init: function () {
          updateNavigationVisibility(this);
        },
        slideChange: function () {
          updateNavigationVisibility(this);
        }
      }
    });

    function updateNavigationVisibility(swiper) {
      const prevButton = document.querySelector('#cart-recommendations-prev');
      const nextButton = document.querySelector('#cart-recommendations-next');

      if (prevButton) {
        prevButton.style.display = swiper.isBeginning ? 'none' : 'flex';
      }

      if (nextButton) {
        nextButton.style.display = swiper.isEnd ? 'none' : 'flex';
      }
    }

    const nextButton = document.querySelector('#cart-recommendations-next');
    const prevButton = document.querySelector('#cart-recommendations-prev');

    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        cartRecSwiper.slideTo(cartRecSwiper.activeIndex + 0.5);
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        console.log("Slide index: " + cartRecSwiper.activeIndex);
        cartRecSwiper.slideTo(cartRecSwiper.activeIndex);
      });
    }
  } catch (e) {
    console.error('Error initializing cart recommendations swiper:', e);
  }
}

// Funcionalidad para navegación de productos complementarios en PDP
function initComplementaryProductsNavigation() {
  const slider = document.getElementById('complementary-products-slider');
  const prevButton = document.querySelector('.complementary-products--nav-prev');
  const nextButton = document.querySelector('.complementary-products--nav-next');

  if (!slider || !prevButton || !nextButton) return;

  const cardWidth = 340; // Ancho de cada tarjeta de producto
  const gap = 10; // Espacio entre tarjetas
  const scrollAmount = cardWidth + gap;

  function updateButtonStates() {
    const isAtStart = slider.scrollLeft <= 0;
    const isAtEnd = slider.scrollLeft >= (slider.scrollWidth - slider.clientWidth - 10);

    prevButton.style.opacity = isAtStart ? '0' : '1';
    prevButton.style.visibility = isAtStart ? 'hidden' : 'visible';
    nextButton.style.opacity = isAtEnd ? '0' : '1';
    nextButton.style.visibility = isAtEnd ? 'hidden' : 'visible';
  }

  prevButton.addEventListener('click', function (e) {
    e.preventDefault();
    slider.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });

  nextButton.addEventListener('click', function (e) {
    e.preventDefault();
    slider.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });

  // Actualizar estado de botones al hacer scroll
  slider.addEventListener('scroll', updateButtonStates);

  // Estado inicial
  updateButtonStates();

  // Observar cambios en el contenido
  const observer = new MutationObserver(updateButtonStates);
  observer.observe(slider, { childList: true, subtree: true });
}

function observeProductRecommendations() {
  const recommendationsContainerId = 'cart-recommendations-swiper';

  function checkRecommendationsLoaded() {
    const container = document.getElementById(recommendationsContainerId);
    if (container && container.querySelector('.swiper-slide')) {
      setTimeout(function () {
        initCartRecommendationsSwiper();
      }, 50);
      return true;
    }
    return false;
  }

  if (checkRecommendationsLoaded()) {
    return;
  }
  const bodyObserver = new MutationObserver(function (mutations) {
    if (checkRecommendationsLoaded()) {
      bodyObserver.disconnect();
    }
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  const checkInterval = setInterval(function () {
    if (checkRecommendationsLoaded()) {
      clearInterval(checkInterval);
    }
  }, 300);
}

function observeComplementaryProducts() {
  function checkComplementaryProductsLoaded() {
    const slider = document.getElementById('complementary-products-slider');
    if (slider && slider.children.length > 1) {
      setTimeout(function () {
        initComplementaryProductsNavigation();
      }, 100);
      return true;
    }
    return false;
  }

  if (checkComplementaryProductsLoaded()) {
    return;
  }

  const bodyObserver = new MutationObserver(function (mutations) {
    if (checkComplementaryProductsLoaded()) {
      bodyObserver.disconnect();
    }
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  const checkInterval = setInterval(function () {
    if (checkComplementaryProductsLoaded()) {
      clearInterval(checkInterval);
    }
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initCartRecommendationsSwiper();
    observeProductRecommendations();
    observeComplementaryProducts();
  });
} else {
  initCartRecommendationsSwiper();
  observeProductRecommendations();
  observeComplementaryProducts();
}

document.addEventListener('product:added', function () {
  setTimeout(observeProductRecommendations, 100);
  setTimeout(observeComplementaryProducts, 100);
});

document.addEventListener('cart:updated', function () {
  setTimeout(observeProductRecommendations, 100);
});

document.addEventListener('click', function (e) {
  if (e.target.matches('button[name="checkout"], button[name="add"], .add-to-cart, .cart-link') ||
    e.target.closest('button[name="checkout"], button[name="add"], .add-to-cart, .cart-link')) {
    setTimeout(observeProductRecommendations, 300);
    setTimeout(observeComplementaryProducts, 300);
  }
});

setTimeout(observeProductRecommendations, 1000);
setTimeout(observeProductRecommendations, 2000);
setTimeout(observeComplementaryProducts, 1000);
setTimeout(observeComplementaryProducts, 2000);